import * as React from 'react';
import styled from 'styled-components'
import { withRouter, RouteComponentProps } from 'react-router-dom';

import AppNotificationWrapper from "../atom/app_notification_wrapper";
import AppNotificationText from "../atom/app_notification_text";

import {AppNotificationMessage,
    AppNotificationType
} from "../../../domain/model/app_notification_message";

interface IProps extends RouteComponentProps<{}> {
    onClose:(id: string) => (e: any) => void;
    appNotificationMessage: AppNotificationMessage;
}

const AppNotificationWithText: React.FC<IProps> = (props) => {

    const {appNotificationMessage, onClose, location} = props;
    let message: string = appNotificationMessage.message;
    const appNotificationType: AppNotificationType = appNotificationMessage.type;
    const id: string = appNotificationMessage.id;

    // Client作成フォームで409エラーの場合、メッセージを日本語に変換
    if (location.pathname === '/client/clients/_create' && message.includes('409')) {
        message = 'このメールアドレスは既に登録されています。';
    }

    return (
        <AppNotificationWrapper appNotificationType={appNotificationType}>
            <AppNotificationText >
                {message}
            </AppNotificationText>
            <CloseButton className="fas fa-times" onClick={onClose(id)}/>
        </AppNotificationWrapper>
    );
};

export default withRouter(AppNotificationWithText);

const CloseButton = styled.i`
  margin-right: 16px;
  &:hover {
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/app_notification_with_text.tsx